
import axiosHandler from '../../Intersepter/axiosInstance';

//  Function to update the FCM token for a user.

export const updateFcmToken = async (payload) => {
  try {
    const response = await axiosHandler.post(`/auth/update-fcm-token`, payload);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};